(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[880],{

/***/ 52006:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ setActiveBreakpoint; }
/* harmony export */ });
/* harmony import */ var redux_actions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88231);
/* harmony import */ var main_javascripts_constants_actionType_BreakpointActionType__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70883);


var setActiveBreakpoint = (0,redux_actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(main_javascripts_constants_actionType_BreakpointActionType__WEBPACK_IMPORTED_MODULE_1__/* .SET_ACTIVE_BREAKPOINT */ .t, function (param) {
  return param;
});

/***/ }),

/***/ 77479:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ MainBlock; }
/* harmony export */ });
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var aphrodite__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34397);
/* harmony import */ var _MainBlockStyle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36745);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(35944);


var _excluded = ["styles", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var MainBlock = function MainBlock(props) {
  var styles = props.styles,
      children = props.children,
      rest = (0,_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props, _excluded);

  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("div", _objectSpread(_objectSpread({
    className: (0,aphrodite__WEBPACK_IMPORTED_MODULE_2__/* .css */ .iv)(_MainBlockStyle__WEBPACK_IMPORTED_MODULE_3__/* .MainBlockStyle.block */ .d.block, styles)
  }, rest), {}, {
    children: children
  }));
};

/***/ }),

/***/ 36745:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ MainBlockStyle; }
/* harmony export */ });
/* harmony import */ var aphrodite__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34397);

var MainBlockStyle = aphrodite__WEBPACK_IMPORTED_MODULE_0__/* .StyleSheet.create */ .mM.create({
  block: {
    boxSizing: "border-box"
  }
});

/***/ }),

/***/ 59941:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* reexport safe */ _MainBlock__WEBPACK_IMPORTED_MODULE_1__.R; }
/* harmony export */ });
/* harmony import */ var _MainBlockStyle__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36745);
/* harmony import */ var _MainBlock__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77479);



/***/ }),

/***/ 69155:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ MainHead_MainHead; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/withTranslation.js + 1 modules
var withTranslation = __webpack_require__(67375);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./main/javascripts/constants/Constants.ts
var Constants = __webpack_require__(25968);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./main/javascripts/utils/cookieUtil.ts
var cookieUtil = __webpack_require__(95893);
// EXTERNAL MODULE: ./main/javascripts/constants/SearchConstants.ts
var SearchConstants = __webpack_require__(12222);
;// CONCATENATED MODULE: ./main/javascripts/hooks/common/useGoogleAnalyticsParameter.tsx




var useGoogleAnalyticsParameter = function useGoogleAnalyticsParameter() {
  var router = (0,next_router.useRouter)();
  (0,react.useEffect)(function () {
    if (router.isReady) {
      var query = router.query;
      var utmSource = query.utm_source;
      var utmMedium = query.utm_medium;
      var utmCampaign = query.utm_campaign;

      if (utmSource) {
        (0,cookieUtil/* setCookie */.d)("utm_source", utmSource, SearchConstants/* UTM_COOKIE_EXPIRATION_DAYS */.F);
      }

      if (utmMedium) {
        (0,cookieUtil/* setCookie */.d)("utm_medium", utmMedium, SearchConstants/* UTM_COOKIE_EXPIRATION_DAYS */.F);
      }

      if (utmCampaign) {
        (0,cookieUtil/* setCookie */.d)("utm_campaign", utmCampaign, SearchConstants/* UTM_COOKIE_EXPIRATION_DAYS */.F);
      }
    }
  }, [router.isReady]);
  return;
};
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
;// CONCATENATED MODULE: ./main/javascripts/components/organisms/MainHead/MainHead.tsx









function MainHead(props) {
  var t = props.t,
      origin = props.origin,
      title = props.title,
      description = props.description,
      noindex = props.noindex;
  var siteNameKey =  true ? "tarip" : 0;
  var localeKey =  true ? "tarip" : 0;
  var siteName = t("constant:seo.".concat(siteNameKey));
  var metaTitle = title || t("constant:seo.".concat(localeKey, "title"));
  var metaDescription = description || t("constant:seo.".concat(localeKey, "description"));
  var sitePath =  true ? "/tarip" : 0;
  useGoogleAnalyticsParameter();
  var router = (0,next_router.useRouter)();
  var ogImageUrl = origin ? "".concat(origin).concat(Constants/* PATH_SCOPE */.j1).concat(sitePath, "/og_image.png") : "";
  var url = origin ? "".concat(origin).concat(Constants/* PATH_SCOPE */.j1).concat(router.asPath) : "";
  var canonical = "";

  if (url) {
    var canonicalUrl = new URL(url);
    var additionalPath =  true ? "/tarip" : 0;
    var pathname =  true && canonicalUrl.pathname === "/" ? "" : canonicalUrl.pathname;
    canonical = "".concat(origin).concat(additionalPath).concat(pathname);
  }

  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
      name: "viewport",
      content: "width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
      rel: "apple-touch-icon",
      sizes: "180x180",
      href: "".concat(Constants/* PATH_SCOPE */.j1).concat(sitePath, "/apple-touch-icon.png")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
      rel: "icon",
      type: "image/png",
      sizes: "32x32",
      href: "".concat(Constants/* PATH_SCOPE */.j1).concat(sitePath, "/favicon-32x32.png")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
      rel: "icon",
      type: "image/png",
      sizes: "16x16",
      href: "".concat(Constants/* PATH_SCOPE */.j1).concat(sitePath, "/favicon-16x16.png")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
      rel: "manifest",
      href: "".concat(Constants/* PATH_SCOPE */.j1).concat(sitePath, "/site.webmanifest")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
      rel: "mask-icon",
      href: "".concat(Constants/* PATH_SCOPE */.j1).concat(sitePath, "/safari-pinned-tab.svg"),
      color: "#fcc800"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
      name: "msapplication-TileColor",
      content: "#000000"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
      name: "theme-color",
      content: "#ffffff"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
      children: "".concat(metaTitle, " | ").concat(siteName)
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
      name: "description",
      content: metaDescription
    }), canonical && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
      rel: "canonical",
      href: canonical
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
      property: "og:title",
      content: "".concat(metaTitle, " | ").concat(siteName)
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
      property: "og:description",
      content: metaDescription
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
      property: "og:type",
      content: "website"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
      property: "og:site_name",
      content: siteName
    }), url && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
      property: "og:url",
      content: url
    }), ogImageUrl && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
      property: "og:image",
      content: ogImageUrl
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
      property: "og:locale",
      content: "ja_JP"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
      property: "fb:app_id",
      content: Constants/* FACEBOOK_APP_ID */.lZ
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
      name: "twitter:card",
      content: "summary"
    }), (noindex || "production" !== "production") && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
      name: "robots",
      content: "noindex"
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
      type: "text/javascript",
      src: Constants/* PAYMENT_TOKEN_URL */.E8
    })]
  });
}

/* harmony default export */ var MainHead_MainHead = ((0,withTranslation/* withTranslation */.Z)(["constant"])(MainHead));

/***/ }),

/***/ 12222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ UTM_COOKIE_EXPIRATION_DAYS; }
/* harmony export */ });
var UTM_COOKIE_EXPIRATION_DAYS = 30;

/***/ }),

/***/ 98198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ FooterContainer; }
/* harmony export */ });
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14416);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);


var Footer = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
  return  true ? Promise.all(/* import() */[__webpack_require__.e(8488), __webpack_require__.e(1566)]).then(__webpack_require__.bind(__webpack_require__, 61566)).then(function (mod) {
    return mod.FooterTravelvision;
  }) : 0;
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(61566), /*require.resolve*/(61566)];
    }
  }
}); // import { Footer, IProps } from "main/javascripts/components/organisms/Footer";

var mapStateToProps = function mapStateToProps(state) {
  return {
    currentUser: state.currentUserReducer.currentUser
  };
};

var FooterContainer = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .connect */ .$j)(mapStateToProps, {})(Footer);

/***/ }),

/***/ 12664:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ HeaderContainer; }
/* harmony export */ });
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14416);
/* harmony import */ var redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14890);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var main_javascripts_actions_Breakpoint__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52006);



var Header = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function () {
  return  true ? Promise.all(/* import() */[__webpack_require__.e(1664), __webpack_require__.e(8609)]).then(__webpack_require__.bind(__webpack_require__, 20713)).then(function (mod) {
    return mod.HeaderTravelvision;
  }) : 0;
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(20713), /*require.resolve*/(20713)];
    }
  }
});


var mapStateToProps = function mapStateToProps(state) {
  return {
    currentUser: state.currentUserReducer.currentUser
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    actions: (0,redux__WEBPACK_IMPORTED_MODULE_3__/* .bindActionCreators */ .DE)({
      setActiveBreakpoint: main_javascripts_actions_Breakpoint__WEBPACK_IMPORTED_MODULE_2__/* .setActiveBreakpoint */ .D
    }, dispatch)
  };
};

var HeaderContainer = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .connect */ .$j)(mapStateToProps, mapDispatchToProps)(Header);

/***/ }),

/***/ 83795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ useConstructor; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useConstructor = function useConstructor(callback) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      isConstructed = _useState[0],
      setIsConstructed = _useState[1];

  if (isConstructed) {
    return [isConstructed, setIsConstructed];
  }

  callback();
  setIsConstructed(true);
  return [isConstructed, setIsConstructed];
};

/***/ }),

/***/ 89490:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14416);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(6339);
/* harmony import */ var humps__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56264);
/* harmony import */ var humps__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(humps__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var main_javascripts_store__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62394);
/* harmony import */ var main_javascripts_containers_organisms_Header_HeaderContainer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12664);
/* harmony import */ var main_javascripts_containers_organisms_Footer_FooterContainer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98198);
/* harmony import */ var main_javascripts_styles_globalStyle__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15305);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59993);
/* harmony import */ var main_javascripts_components_organisms_MainHead_MainHead__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69155);
/* harmony import */ var main_javascripts_hooks_common_useConstructor__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(83795);
/* harmony import */ var main_javascripts_components_atoms_Block_MainBlock__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(59941);
/* harmony import */ var main_javascripts_features_post_postSlice__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(78121);
/* harmony import */ var main_javascripts_features_post_components_PostShowMain__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(42004);
/* harmony import */ var main_javascripts_features_search_searchPageSlice__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(54231);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(35944);


















function ArticleShow(props) {
  var post = props.post,
      html = props.html,
      locale = props.locale;
  var _post$metaTags = post.metaTags,
      title = _post$metaTags.title,
      description = _post$metaTags.description;
  (0,main_javascripts_hooks_common_useConstructor__WEBPACK_IMPORTED_MODULE_9__/* .useConstructor */ .g)(function () {
    var _post$searchTypes;

    main_javascripts_store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,main_javascripts_features_post_postSlice__WEBPACK_IMPORTED_MODULE_11__/* .initPost */ .iF)(post));

    if (((_post$searchTypes = post.searchTypes) === null || _post$searchTypes === void 0 ? void 0 : _post$searchTypes.length) > 0) {
      main_javascripts_store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,main_javascripts_features_search_searchPageSlice__WEBPACK_IMPORTED_MODULE_13__/* .changeSearchCategory */ .xc)((0,humps__WEBPACK_IMPORTED_MODULE_2__.camelize)(post.searchTypes[0])));
    }

    if (i18n__WEBPACK_IMPORTED_MODULE_7__/* ["default"].language */ .Z.language !== locale) {
      void i18n__WEBPACK_IMPORTED_MODULE_7__/* ["default"].changeLanguage */ .Z.changeLanguage(locale);
    }

    main_javascripts_styles_globalStyle__WEBPACK_IMPORTED_MODULE_6__/* .extended.css */ .bU.css(main_javascripts_styles_globalStyle__WEBPACK_IMPORTED_MODULE_6__/* .defaultStyles */ .jF[main_javascripts_styles_globalStyle__WEBPACK_IMPORTED_MODULE_6__/* .GLOBALS */ .UH]);
  });
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    main_javascripts_store__WEBPACK_IMPORTED_MODULE_3__/* .store.dispatch */ .h.dispatch((0,main_javascripts_features_post_postSlice__WEBPACK_IMPORTED_MODULE_11__/* .putPostAccess */ .lK)({
      id: post.id
    }));
  }, []);
  var origin = "https://www.travelvision.jp";
  return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(react_redux__WEBPACK_IMPORTED_MODULE_1__/* .Provider */ .zt, {
    store: main_javascripts_store__WEBPACK_IMPORTED_MODULE_3__/* .store */ .h,
    children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(main_javascripts_components_organisms_MainHead_MainHead__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
      origin: origin,
      title: title,
      description: description
    }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsxs */ .BX)(react_i18next__WEBPACK_IMPORTED_MODULE_15__/* .I18nextProvider */ .a, {
      i18n: i18n__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z,
      children: [(0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(main_javascripts_containers_organisms_Header_HeaderContainer__WEBPACK_IMPORTED_MODULE_4__/* .HeaderContainer */ .g, {}), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(main_javascripts_components_atoms_Block_MainBlock__WEBPACK_IMPORTED_MODULE_10__/* .MainBlock */ .R, {
        children: (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(main_javascripts_features_post_components_PostShowMain__WEBPACK_IMPORTED_MODULE_12__.PostShowMain, {
          html: html
        })
      }), (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__/* .jsx */ .tZ)(main_javascripts_containers_organisms_Footer_FooterContainer__WEBPACK_IMPORTED_MODULE_5__/* .FooterContainer */ .b, {})]
    })]
  });
}

var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (ArticleShow);

/***/ }),

/***/ 57857:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/[postId]",
      function () {
        return __webpack_require__(89490);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2070,9121,7761,4890,7269,7172,7476,4397,4170,9923,7536,4602,6688,9491,1214,7744,8808,3240,6160,9993,2496,4409,8740,5147,1185,5472,6555,2577,5284,4085,9265,6944,831,9919,2004,9774,2888,179], function() { return __webpack_exec__(57857); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);